import { setBodyCssVar } from '@/helpers/vueHelpers.js'

export default {
  mounted() {
    setBodyCssVar('--site-mb', '0px')
  },
  beforeUnmount() {
    setBodyCssVar('--site-mb', null)
  },
}
